import ServiceCRUD from '../../../../services/ServiceCRUDFLEXUC';
import { apiUc } from '../../../../http';

class RoleService extends ServiceCRUD {
  constructor() {
    super(`/api/roles`);
  }
  getUserRoles(userLogin) {
    return apiUc.get(`${this.path}/user/${userLogin}`);
  }
}

export default new RoleService();
